import { Logo } from '@/components/logo';
import { Separator } from '@/components/ui/separator';

const PRODUCT_LINKS = [
  { href: '#features', label: 'Funcionalidades' },
  { href: '#how-it-works', label: 'Integración' },
  { href: '#compliance', label: 'Cumplimiento' },
] as const;

const LEGAL_LINKS = [
  { href: '#compliance', label: 'WCAG 2.2 AA' },
  { href: 'https://peninsula.co/wp-content/uploads/2025/07/Politica-de-seguridad-de-la-informacion-ISO_ENS-ES.pdf', label: 'ISO 27001', external: true },
  { href: 'https://peninsula.co/terminos', label: 'RGPD / LOPDGDD', external: true },
] as const;

export function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer className="bg-peninsula-graphite text-white" role="contentinfo">
      <div className="mx-auto max-w-7xl px-4 py-12 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 gap-8 sm:grid-cols-2 lg:grid-cols-4">
          {/* Branding */}
          <div className="sm:col-span-2 lg:col-span-1">
            <Logo dark />
            <p className="mt-3 text-sm text-white/60 max-w-xs">
              Servicio de vocalización online para portales web accesibles.
            </p>
          </div>

          {/* Producto */}
          <div>
            <h3 className="text-sm font-semibold text-white">Producto</h3>
            <ul className="mt-3 space-y-2" role="list">
              {PRODUCT_LINKS.map((link) => (
                <li key={link.label}>
                  <a
                    href={link.href}
                    className="text-sm text-white/60 hover:text-white transition-colors"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h3 className="text-sm font-semibold text-white">Cumplimiento</h3>
            <ul className="mt-3 space-y-2" role="list">
              {LEGAL_LINKS.map((link) => (
                <li key={link.label}>
                  <a
                    href={link.href}
                    {...('external' in link && link.external
                      ? { target: '_blank', rel: 'noopener noreferrer' }
                      : {})}
                    className="text-sm text-white/60 hover:text-white transition-colors"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Contacto */}
          <div>
            <h3 className="text-sm font-semibold text-white">Contacto</h3>
            <ul className="mt-3 space-y-2" role="list">
              <li>
                <a
                  href="https://peninsula.co/contacto"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-sm text-white/60 hover:text-white transition-colors"
                >
                  Contacto
                </a>
              </li>
              <li>
                <a
                  href="/admin/login"
                  className="text-sm text-white/60 hover:text-white transition-colors"
                >
                  Panel de administración
                </a>
              </li>
            </ul>
          </div>
        </div>

        <Separator className="my-8 bg-white/10" />

        <div className="flex flex-col items-center justify-between gap-4 sm:flex-row">
          <p className="text-xs text-white/60">
            &copy; {year} Readable. Todos los derechos reservados.
          </p>
          <p className="text-xs text-white/60">
            Desarrollado por{' '}
            <a
              href="https://peninsula.co"
              target="_blank"
              rel="noopener noreferrer"
              className="font-medium text-white hover:text-peninsula-magma transition-colors"
            >
              peninsula.co
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
}
